import { ExtraWorkCountFields } from "entities/ExtraWorkField";
import React from "react";
import { NumberInput, useTranslate } from "react-admin";

import { FormGroupGrid, GridInput, GridInputMultiChanges } from "../../../components/GridForm";
import { YesNoInput } from "../../../components/inputs/YesNoInput";
import HideableOrderField from "../../../entities/HideableOrderField";

export const ExtraWorkSection = ({
	isFieldHidden,
	isMultiChanges = false,
	disabled = false,
	...props
}) => {
	const translate = useTranslate();
	const Input = isMultiChanges ? GridInputMultiChanges : GridInput;
	const resettable = isMultiChanges;

	return (
		<FormGroupGrid
			xs={12}
			md={12}
			lg={12}
			{...props}
			title={translate("resources.orders.block-label.extra-work")}
			hidden={
				isFieldHidden(HideableOrderField.EXTRA_LOADING_TIME) &&
				isFieldHidden("is_extra_loading_time_billable")
			}
		>
			<Input
				xs={6}
				sm={4}
				lg={2}
				component={NumberInput}
				options={{ format: "" }}
				source="extra_loading_time"
				resettable={resettable}
				disabled={disabled}
				hidden={isFieldHidden(HideableOrderField.EXTRA_LOADING_TIME)}
			/>
			<Input
				xs={6}
				sm={4}
				lg={2}
				component={YesNoInput}
				source="is_extra_loading_time_billable"
				defaultValue={false}
				disabled={disabled}
				hidden={isFieldHidden("is_extra_loading_time_billable")}
			/>
			{ExtraWorkCountFields.map((source) => (
				<Input
					key={source}
					xs={6}
					sm={4}
					lg={2}
					component={NumberInput}
					options={{ format: "" }}
					source={source}
					resettable={resettable}
					disabled={disabled}
					hidden={isFieldHidden(source)}
				/>
			))}
		</FormGroupGrid>
	);
};
